export function isInteractedUIEvent(event) {
  return event.payload.action !== undefined;
}
export function isScreenUIEvent(event) {
  return event.payload.name !== undefined;
}